module.exports = __webpack_public_path__ + "static/img/1_9_1.b4f4d16d.jpg";